import { useRef, useState } from "react";
import { v4 as uuid } from "uuid";
import { useStudio, useYArray, useYMap } from "./StudioContext.js";
import { Section, yPush } from "./form_primitives.js";
import { formLabel as label } from "./techpack_form_contract.js";

export function ProductionFittingComments() {
  const { techPack, languageCode: lang, userId } = useStudio();
  const entries = useYArray(techPack.production_fitting_comments);
  const metadata = useYMap(techPack.metadata);
  const [comment, setComment] = useState("");
  const [role, setRole] = useState("");
  const [status, setStatus] = useState("");
  const [hint, setHint] = useState("");
  const commentRef = useRef<HTMLTextAreaElement>(null);
  function append() {
    if (!comment.trim()) {
      setHint(label("comment", lang));
      commentRef.current?.focus();
      return;
    }
    yPush(techPack.production_fitting_comments, {
      id: uuid(), date: new Date().toISOString(),
      version_ref: String(metadata.get("_canonical_version_id")?.value || "draft"),
      author_id: userId || null, author_role: role.trim() || undefined, comment: comment.trim(), status: status || undefined,
    });
    setComment("");
    setStatus("");
    setHint("");
  }
  return <Section title={label("comments", lang)}>
    <ol className="sf-comment-history">{entries.length === 0 && <li>{label("empty", lang)}</li>}{entries.map(entry => <li key={entry.id}>
      <div>{label("date", lang)}: <time dateTime={entry.date}>{new Date(entry.date).toLocaleString(lang)}</time> · {label("version", lang)}: {entry.version_ref}</div>
      <div>{label("author", lang)}: {entry.author_id || "—"}{entry.author_role ? ` · ${entry.author_role}` : ""}</div><div>{label("status", lang)}: {entry.status ? label(entry.status, lang) : ""}</div>
      <p style={{whiteSpace:"pre-wrap"}}>{entry.comment}</p>
    </li>)}</ol>
    <label className="sf-label">{label("role", lang)}<input className="sf-input" value={role} onChange={e => setRole(e.target.value)} /></label><label className="sf-label">{label("status", lang)}<select className="sf-select" aria-label={label("status", lang)} value={status} onChange={e => setStatus(e.target.value)}><option value="">—</option>{["sample","approved","production","rejected"].map(s => <option key={s} value={s}>{label(s, lang)}</option>)}</select></label>
    <label className="sf-label">{label("comment", lang)}<textarea ref={commentRef} className="sf-textarea" value={comment} onChange={e => { setComment(e.target.value); setHint(""); }} /></label>
    <button className="sf-add-btn" aria-describedby="sf-comment-add-hint" title={label("add", lang)} onClick={append}>{`+ ${label("add", lang)} ${label("comment", lang)}`}</button>
    <p className="sf-add-hint" id="sf-comment-add-hint" role="status" aria-live="polite">{hint}</p>
  </Section>;
}
